import { global } from ":shared/app";

export type GET = {
  returns: {
    id: number;
    first_name: string;
    last_name: string;
    gender: string;
    email: string;
    track: string;
    user_type: number;
    first_sign_in: boolean;
    major: string;
    portfolio: string;
    bio: string;
    image: string;
    reference2: string;
  };
};

export const endpoints = {
  get: "account/user/",
  put: "account/user/update/",
};
export async function get(): Promise<GET["returns"]> {
  return global.api
    .getAuth<GET["returns"]>(endpoints.get)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err.message);
    });
}

export type PUT = {
  props: Partial<GET["returns"] & { image: File }>;
};
export async function put(data: PUT["props"]) {
  const formData = new FormData();

  for (const v in data) {
    const value = data[v];
    if (v !== "image") {
      formData.append(v, value);
    } else if (value?.[0] != undefined) {
      formData.append("image", value?.[0]);
    }
  }
  return global.api
    .putAuth(endpoints.put, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(async (res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}
